import React, { forwardRef } from 'react';
import { injectIntl } from 'react-intl';

/**
 * If a child component is wrapped with injectIntl, we cant pass ref from the parent to child.
 * This HOC is written to pass the ref to the component which is wrapped with injectIntl
 * @param {ReactComponent} Component
 */
function withIntl(Component) {
  class Wrapper extends React.Component {
    render() {
      const { innerRef, ...props } = this.props;
      return <Component ref={innerRef} {...props} />;
    }
  }
  const IntlWrapper = injectIntl(Wrapper);
  return forwardRef((props, ref) => <IntlWrapper {...props} innerRef={ref} />);
}

export default withIntl;
